import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { importWithChunkReload } from '@/utils/lazyRetry';
import { MessageSquarePlus } from 'lucide-react';
import { lazy, Suspense, useState } from 'react';
import { Button } from '@/components/ui/button';

// Lazy so the feedback stack (html2canvas, react-sketch-canvas,
// browser-image-compression) stays out of the entry chunk; Header is part of
// the always-loaded app shell.
const FeedbackDialog = lazy(() =>
  importWithChunkReload(() =>
    import('./FeedbackDialog').then((module) => ({ default: module.FeedbackDialog }))
  )
);

export const FeedbackHeaderButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [shouldMountDialog, setShouldMountDialog] = useState(false);
  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        aria-label="Send feedback"
        title="Send feedback"
        data-testid="header_feedbackBtn"
        onClick={() => {
          setShouldMountDialog(true);
          setIsOpen(true);
        }}
        className="h-11 gap-1.5 rounded-md px-2 text-primary lg:h-8 lg:min-h-0"
      >
        <MessageSquarePlus className="h-4 w-4" aria-hidden="true" />
        <span className="hidden sm:inline">Feedback</span>
      </Button>
      {shouldMountDialog && (
        <ErrorBoundary
          fallback={<span role="alert">Feedback unavailable. Please reload to try again.</span>}
        >
          <Suspense fallback={null}>
            <FeedbackDialog open={isOpen} onOpenChange={setIsOpen} />
          </Suspense>
        </ErrorBoundary>
      )}
    </>
  );
};
